import { StrictMode } from 'react';

import { PreferenceProvider } from '@praetoid/ui';
import { QueryClientProvider } from '@tanstack/react-query';
import { LazyMotion, domAnimation } from 'motion/react';

import { AuthProvider } from '~/context/AuthProvider';
import { queryClient } from '~/lib/queryClient';

import { Router } from './Router';

console.log(queryClient);

const PraetoidInterface = () => (
	<StrictMode>
		<QueryClientProvider client={queryClient}>
			<LazyMotion features={domAnimation}>
				<PreferenceProvider storageKey="preferences">
					<AuthProvider>
						<Router />
					</AuthProvider>
				</PreferenceProvider>
			</LazyMotion>
		</QueryClientProvider>
	</StrictMode>
);

export default PraetoidInterface;
